module.exports = __webpack_public_path__ + "static/media/axlir.001424bc.png";